import { render, staticRenderFns } from "./tag-raw-material.vue?vue&type=template&id=50c7ac4e"
import script from "./tag-raw-material.vue?vue&type=script&lang=js"
export * from "./tag-raw-material.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports